import {FC, ReactNode, useState} from 'react';
//mui
import {Box, useMediaQuery} from '@mui/material';
//images
import {ReactComponent as Sort} from '@icons/sort.svg';
//components
import DefaultDropdown from '../../Dropdown';
import Button from '@components/Button';
//constants
import {FILTER, TEXT} from '@/utils/constants';
//styles
import {filterMenuStyle} from './FilterMenu.styles';

interface FilterMenuProps {
	content: ReactNode;
	isCloseBackdrop?: boolean;
	onOpenDropdown?: () => void;
	isMobileMode?: boolean;
}

const FilterMenu: FC<FilterMenuProps> = ({content, isCloseBackdrop, onOpenDropdown, isMobileMode}) => {
	const [isOpened, setIsOpened] = useState(false);

	const handleOpen = () => {
		if (isMobileMode && onOpenDropdown) onOpenDropdown();
		else setIsOpened(!isOpened);
	};

	const isMobile = useMediaQuery('(max-width:768px)');

	return (
		<Box sx={filterMenuStyle.wrapper}>
			<DefaultDropdown
				toggleContent={
					<Box sx={filterMenuStyle.buttonWrap}>
						<Button
							startIcon={<Sort />}
							disableRipple
							variant={TEXT}
							title={isMobile ? '' : FILTER}
							sx={{...(isOpened ? filterMenuStyle.activeButton : filterMenuStyle.button)}}
						/>
					</Box>
				}
				options={<Box sx={filterMenuStyle.option}>{content}</Box>}
				onOpen={handleOpen}
				onClose={handleOpen}
				open={isOpened}
				isCloseBackdrop={isCloseBackdrop}
			/>
		</Box>
	);
};

export default FilterMenu;
